export default __webpack_public_path__ + "static/media/dahyun2.a50775d7.jpg";